import { useMemberSignIn } from '../../Hooks/useMemberSignIn';

/**
 * Vite/React Router adapter for package signup.
 * Package `CreateAccountLink` uses Next.js `useRouter`; this calls the same
 * `useAuthActions().register()` path via `useMemberSignIn`.
 */
export default function CreateAccountLink({
  className = 'portal-link-btn',
  children = 'Create account',
  redirectTo = '/dashboard',
  disabled,
  onError,
}) {
  const { register, pending, pendingLabel } = useMemberSignIn({
    redirectTo,
    onError,
  });

  return (
    <button
      type="button"
      className={className}
      disabled={disabled || pending}
      onClick={() => {
        register().catch(() => {});
      }}
    >
      {pending ? pendingLabel : children}
    </button>
  );
}
